import React from "react";

const Input = ({
  name,
  label,
  value,
  onChange,
  error,
  type = "checkbox",
  search,
  onClick,
  placeholder = "",
  onKeyPress,
  onKeyDown,
  maxLength=500,
  disabled=false,
  checked,
  className = "btn btn-primary",
}) => {
  const handleOnclick = () => {
    onClick(true);
  };
  // console.log(value);
  return (
    <div className="from-group ">
      <div className="form-check form-check-inline">
      { label && <label className="form-check-label" >{label} </label> }
        <input
          value={value}
          onChange={onChange}
          id={name}
          name={name}
          type={type}
          disabled ={disabled}
          checked={checked}
          maxLength = {maxLength}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          className="form-check-input mt-2"
          style={{fontSize: "15px" }}
        ></input>

        {search && (
         
            <button
              type="button"
              // id="show-contact-modal-button"
              className="btn btn-primary"
              disabled ={disabled}
              onClick={handleOnclick}
            >
              {search}
            </button>
     
        )}
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
